import React, { useState } from "react";
import { Form, Button, Card, Container } from "react-bootstrap";
import { serverUrl } from "../../serverUrl";
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { FaEnvelope, FaArrowLeft } from 'react-icons/fa';

function ForgotPassword() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ email: '' });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    function handleSubmit(e) {
        e.preventDefault();
        setIsSubmitting(true);

        serverUrl
            .post("/users/request-reset-email/", {
                email: formData.email,
            })
            .then((res) => {
                toast.success(`Check your email - we've sent password reset instructions`);
                navigate('/login');
            })
            .catch((error) => {
                toast.error(error.response?.data?.error || 'An error occurred. Please try again.');
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    }

    return (
        <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
            <div className="w-100" style={{ maxWidth: "500px" }}>
                <Card className="shadow">
                    <Card.Body>
                        
                        
                        <h2 className="text-center mb-4">Forgot Password?</h2>
                        <p className="text-muted text-center mb-4">
                            Enter your email address and we'll send you a link to reset your password.
                        </p>
                        
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3 p-3">
                                <Form.Label visuallyHidden>Email address</Form.Label>
                                <div className="input-group">
                                    <span className="input-group-text">
                                        <FaEnvelope />
                                    </span>
                                    <Form.Control
                                        type="email"
                                        placeholder="Enter your email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                            </Form.Group>
                            
                            <Button 
                                variant="primary" 
                                type="submit" 
                                className="w-100 mb-3"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Sending...' : 'Send Reset Link'}
                            </Button>
                            
                            <div className="text-center mt-3">
                                <Button 
                                    variant="link" 
                                    onClick={() => navigate('/login')}
                                    className="text-decoration-none"
                                >
                                    Remember your password? Sign in
                                </Button>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </Container>
    );
}

export default ForgotPassword;